import { onBeforeUnmount, ref, watch } from "vue";

export const BUSY_SPINNER_DELAY_MS = 150;

export const BUSY_SPINNER_MIN_VISIBLE_MS = 300;

export const useBusySpinner = (isBusy: () => boolean) => {
  const showSpinner = ref(false);

  let showTimer: ReturnType<typeof setTimeout> | null = null;

  let hideTimer: ReturnType<typeof setTimeout> | null = null;

  let shownAt = 0;

  const clearTimers = (): void => {
    if (showTimer) {
      clearTimeout(showTimer);

      showTimer = null;
    }

    if (hideTimer) {
      clearTimeout(hideTimer);

      hideTimer = null;
    }
  };

  const onBusyChange = (busy: boolean): void => {
    clearTimers();

    if (busy) {
      if (showSpinner.value) {
        return;
      }

      showTimer = setTimeout(() => {
        showSpinner.value = true;

        shownAt = Date.now();
      }, BUSY_SPINNER_DELAY_MS);

      return;
    }

    if (!showSpinner.value) {
      return;
    }

    const remaining = BUSY_SPINNER_MIN_VISIBLE_MS - (Date.now() - shownAt);

    if (remaining <= 0) {
      showSpinner.value = false;

      return;
    }

    hideTimer = setTimeout(() => {
      showSpinner.value = false;
    }, remaining);
  };

  watch(isBusy, onBusyChange, { immediate: true });

  onBeforeUnmount(clearTimers);

  return { showSpinner };
};
